const DetailRow = ({ label, value }) => {
  return (
    <p className="text-xs text-yankee_blue font-semibold mb-2">
      <span className="font-normal text-morning_blue">{label}:</span> {value}
    </p>
  );
};

export default DetailRow;
